export const theme = {
  colors: {
    white: '#ffffff',
    textPrimary: '#696969',
    black: '#000000',
    appBg: 'rgba(227, 253, 211, 0.7)',
    buttonBg: 'linear-gradient(to right, #d3cce3, #e9e4f0)',
    bodyBg: 'linear-gradient(to right, #a1ffce, #faffd1)',
  },
};
